import ECSEditorContext from 'contexts/ECSEditorContext';
import ECSWorldContext from 'contexts/ECSWorldContext';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import DomElement from 'editor/components/DomElement';
import Markup from 'editor/components/Markup';
import RemoveBtn from 'editor/components/RemoveBtn';
import React, { FC, useContext, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: React.ReactNode;
  markupComp: Markup; // NOTE: Should this just accept a regular Markup Record?
  sheetComp: CarnivoreSheet;
};

const MarkupAnchorPortal: FC<Props> = (props: Props) => {
  const { markupComp, sheetComp, children } = props;

  const world = useContext(ECSWorldContext);
  const { doc: carnDoc, domOverlay } = useContext(ECSEditorContext);
  const [portal, setPortal] = useState<React.ReactPortal | null>(null);

  useEffect(() => {
    const portalEl = document.createElement('div');
    const _portal = ReactDOM.createPortal(children, portalEl);
    setPortal(_portal);

    const _btnEntity = world
      .createEntity()
      .add(carnDoc)
      .add(domOverlay)
      .add(markupComp)
      .add(sheetComp) // TBD - can sheet bounds be passed instead of sheetComp:CarnivoreSheet? (literally only used for height)
      .add(new DomElement(portalEl))
      .add(new RemoveBtn());

    return () => {
      if (_btnEntity) {
        _btnEntity.destroy();
      }
    };
  }, []);

  return portal;
};

export default MarkupAnchorPortal;
